
import * as React from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    ReferenceInput,
    SelectInput,
} from 'react-admin';
import EnvironmentTitle from './EnvironmentTitle';

const EnvironmentEdit = props => (
    <Edit title={<EnvironmentTitle />} {...props}>
        <SimpleForm>
            <TextInput source="name" />
            <TextInput source="slug" />
            <ReferenceInput label="Project" source="project_id" reference="projects">
                <SelectInput optionText="name" />
            </ReferenceInput>
        </SimpleForm>
    </Edit>
);

export default EnvironmentEdit;